import { render, staticRenderFns } from "./revenueshare-create.vue?vue&type=template&id=2ea7da07&"
import script from "./revenueshare-create.vue?vue&type=script&lang=js&"
export * from "./revenueshare-create.vue?vue&type=script&lang=js&"
import style0 from "./revenueshare-create.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports